/**
 * constantes de la app
 */


//  Artículos   
export const NO_DEFECTUOSO = '1';
export const DEFECTUOSO = '2';

// Tipos de Avisos a clientes, referente a
export const AVISO_TIPO_GENERAL = '1';
export const AVISO_TIPO_PEDIDO = '2';
export const AVISO_TIPO_ENTRADA = '3';

//  Entradas   
export const ENTRADA_NO_VALIDADA = '1';
export const ENTRADA_VALIDADA = '2';
// 1=Desde IntranetCliente / 2=Desde InnovaCen Administrador
export const ENTRADA_ORIGEN_CLIENTE = '1';
export const ENTRADA_ORIGEN_ADMINISTRADOR = '2';

//swValidado
export const SW_VALIDADO_NO = '1';
export const SW_VALIDADO_SI = '2';


//////////////////////////
//  ESTADOS en tablas   //
//////////////////////////


// Campañas (Estados de recogidas)
export const ESTADO_CAMPANYA_PENDIENTE = '1';
export const ESTADO_CAMPANYA_PARCIALMENTE_ASIGNADA = '2';
export const ESTADO_CAMPANYA_ASIGNADA = '3';
export const ESTADO_CAMPANYA_EN_PROCESO = '4';
export const ESTADO_CAMPANYA_COMPLETADA = '6';
export const ESTADO_CAMPANYA_INCIDENCIA = '8';

// Campañas (Estados de preparaciones)
export const ESTADO_CAMPANYA_PREPARACION_PENDIENTE = '1';
export const ESTADO_CAMPANYA_PREPARACION_EN_PROCESO = '2';
export const ESTADO_CAMPANYA_PREPARACION_COMPLETADO = '3';
export const ESTADO_CAMPANYA_PREPARACION_INCIDENCIA = '8';

// Entradas
export const ESTADO_ENTRADA_PENDIENTE = '1';
export const ESTADO_ENTRADA_EN_PROCESO = '2';
export const ESTADO_ENTRADA_VALIDADA = '3';
export const ESTADO_ENTRADA_INCIDENCIA = '8';

// Pedidos
export const ESTADO_PEDIDO_PENDIENTE = '1';
export const ESTADO_PEDIDO_EN_PREPARACION = '2';
export const ESTADO_PEDIDO_SERVIDO = '3';
export const ESTADO_PEDIDO_CANCELADO = '4';
export const ESTADO_PEDIDO_SERVIDO_PARCIALMENTE = '5';
export const ESTADO_PEDIDO_INCIDENCIA = '8';


// Pedidos Externos
export const ESTADO_PEDIDO_EXT_NO_VALIDADO = '1';
export const ESTADO_PEDIDO_EXT_PENDIENTE = '2';
export const ESTADO_PEDIDO_EXT_CARGADO = '3';
export const ESTADO_PEDIDO_EXT_ELIMINADO = '4';
export const ESTADO_PEDIDO_EXT_ARTICULO_NO_EXISTE = '81';
export const ESTADO_PEDIDO_EXT_ARTICULO_SIN_STOCK = '82';
export const ESTADO_PEDIDO_EXT_SIN_DETALLE = '83';
export const ESTADO_PEDIDO_EXT_SIN_NUM_PEDIDO = '84';
export const ESTADO_PEDIDO_EXT_CLIENTE_DESCONOCIDO = '85';
export const ESTADO_PEDIDO_EXT_PEDIDO_DUPLICADO = '86';



// Preparaciones estado
export const ESTADO_PREPARACION_PENDIENTE = '1';
export const ESTADO_PREPARACION_EMPEZADO = '2';
export const ESTADO_PREPARACION_COMPLETADA = '3';
export const ESTADO_PREPARACION_ERROR = '8';

// Preparaciones estado_uic
export const ESTADO_PREPARACION_UIC_PENDIENTE = '1';
export const ESTADO_PREPARACION_UIC_EMPEZADA = '2';
export const ESTADO_PREPARACION_UIC_COMPLETADA = '3';
export const ESTADO_PREPARACION_UIC_INCIDENCIA = '8';



// Repartos
export const ESTADO_REPARTO_NORMAL = '1';
export const ESTADO_REPARTO_FINALIZADO = '3';
export const ESTADO_REPARTO_CANCELADO_EN_PEDIDO = '5';
export const ESTADO_REPARTO_INCIDENCIA = '8';


// UIC's
export const ESTADO_UIC_DISPONIBLE = '1';
export const ESTADO_UIC_EN_RECOGIDA = '2';
export const ESTADO_UIC_EN_PREPARACION = '3';
export const ESTADO_UIC_CADUCADO = '4';
export const ESTADO_UIC_LLENO = '6';
